import {
  formatCheckoutPurchasedData,
  formatCompletedOrderData,
} from './functions';

export const userCheckoutPurchased = orders => {
  const data = formatCheckoutPurchasedData(orders);

  return {
    type: 'Checkout purchased',
    data,
  };
};

export const userCompletedOrder = orders => {
  const data = formatCompletedOrderData(orders);
  return {
    type: 'Order Completed',
    data,
  };
};
